import {
  Text, Flex, Box
} from '@huspy/briks-web';
import { useTranslation } from 'react-i18next';
import useGetCreditsTransactions from '@modules/core/hooks/queries/useGetCreditsTransactions';
import usePersistUser from '@modules/core/hooks/usePersistUser';
import { CreditsRoute } from '@modules/core/presentation/v2/routes';
import TransactionsTable from './components/TransactionsTable';

const TransactionsList = () => {
  const { t } = useTranslation();

  const { user } = usePersistUser();

  const q = CreditsRoute.useSearch();

  const { data, isLoading } = useGetCreditsTransactions(q, user?.brokerageId);

  const transactions = data?.transactions;

  return (
    <Flex direction='column' w='100%'>
      <Box>
        <Text size='2xl' weight='medium'>{t('core.credits.creditHistory')}</Text>
        <Box paddingTop={ 1 }>
          <Text size='md' color='text-tertiary'>{t('core.credits.creditHistoryDescription')}</Text>
        </Box>
      </Box>

      <Flex paddingTop={ 6 }>
        {
          transactions && transactions?.length > 0
            ? <TransactionsTable data={ data } isLoading={ isLoading } />
            : <Text color='text-secondary'>{t('core.credits.noTransactions')}</Text>
        }
      </Flex>
    </Flex>
  );
};

export default TransactionsList;
